import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TextFormattingService {
  removeNonAsciiChars(
    value: string,
  ): string {
    if (!value) {
      return '';
    }

    return value.replace(/[^\x00-\x7F]/g, '');
  }
}
